var $window       = $(window);
var lastScrollTop = 0;
var $header       = $('.main-header');
var headerHeight  = $header.outerHeight();

$window.scroll(function() {

    var windowTop  = $window.scrollTop();

    if ( windowTop >= headerHeight ) {
      $header.addClass( 'header-sticky' );
    } else {
      $header.removeClass( 'header-sticky' );
      $header.removeClass( 'header-sticky-show' );
    }
  
    if ( $header.hasClass( 'header-sticky' ) ) {
      if ( windowTop < lastScrollTop ) {
        $header.addClass( 'header-sticky-show' );
      } else {
        $header.removeClass( 'header-sticky-show' );
      }
    }
    lastScrollTop = windowTop;
} );




$(document).on('click', ".video-btn", function(e) {
  e.preventDefault();
  $(".video-popup-overlay,.video-popup-iframe-container,.video-popup-container,.video-popup-close").show();
  
  var srchref='',autoplay='',id=$(this).data('id');
  if($(this).data('type') == 'vimeo') var srchref="//player.vimeo.com/video/";
  else if($(this).data('type') == 'youtube') var srchref="https://www.youtube.com/embed/";
  
  if($(this).data('autoplay') == true) autoplay = '?autoplay=1';
  
  $(".video-popup-iframe").attr('src', srchref+id+autoplay);
  
  $(".video-popup-iframe").on('load', function() {
    $(".video-popup-container").show();
  });
});

$(".video-popup-close, .video-popup-overlay").on('click', function(e) {
  $(".video-popup-iframe-container,.video-popup-container,.video-popup-close,.video-popup-overlay").hide();
  $(".video-popup-iframe").attr('src', '');
});




$(document).ready(function(){


    if(readCookie("cookie_accepted") == "1"){
        $(".newsletter-modal-wrap").hide();
    }
    else{
        $(".newsletter-modal-wrap").show();
            $('.close-arrow').click(function(){
            $('.newsletter-modal-wrap').fadeOut();
            createCookie("cookie_accepted", 1, 365);
        });     
    } 



$('a[href*="#"]')
.not('[href="#"]')
.not('[href="#0"]')
.not('.tab-btn a')
.click(function(event) {
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
    && 
    location.hostname == this.hostname
  ) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000, function() {
        var $target = $(target);
        $target.focus();
        if ($target.is(":focus")) { 
          return false;
        } else {
          $target.attr('tabindex','-1');
          $target.focus(); 
        };
      });
    }
  }
});


});


function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function createCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
};

if ($(Window).width() < 768) {
  $(".branding-hero__bottom-items").slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: "linear",
      variableWidth: true,
      arrows: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
  
if ($(Window).width() < 992) {
  $(".trust-review-content").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      pauseOnHover: false,
      dots: true
    });
  }




  // enable form button
  $('#terms-and-privacy').on('change', function () {
    const submitButton = $('.form-submit-btn');
    if ($(this).is(':checked')) {
        submitButton.removeClass('form-submit-btn_disabled');
    } else {
        submitButton.addClass('form-submit-btn_disabled');
    }
});




// mobile menu-drawer
$('.nav-wrap__ham').click(function () {
  $('body').addClass('menu-drawer-open');
})
$('.nav-wrap__cross').click(function () {
  $('body').removeClass('menu-drawer-open');
})